import { useEffect, useState, useCallback } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

// Tools that start OFF for members until an admin switches them on in the
// Admin panel (new or beta tools). Admins can still open them to try them.
export const DEFAULT_OFF = new Set(['sim']);
export const toolOn = (status, id) => (DEFAULT_OFF.has(id) ? status[id] === true : status[id] !== false);

export function useToolStatus() {
  const [disabled, setDisabled] = useState({});

  useEffect(() => {
    return onSnapshot(doc(db, 'config', 'toolStatus'), (snap) => {
      setDisabled(snap.exists() ? snap.data() : {});
    });
  }, []);

  const isEnabled = useCallback((toolId) => toolOn(disabled, toolId), [disabled]);

  return { isEnabled };
}
